module.exports = __webpack_public_path__ + "static/ASIAIR-8e821f6b3198a350ff751310e63ff598.png";